export const SIDEBAR_USER_FLAGS = [
  "user_sidebar_home_user",
  "user_sidebar_price_product_atem",
  "user_sidebar_employee",
  "user_sidebar_product_nozzle",
  "user_sidebar_your_sales",
  "user_sidebar_metrics_and_campaigns",
  "user_sidebar_goal_and_commissions",
  "user_sidebar_hide_performance_management",
  "user_sidebar_road_load",
  "user_sidebar_communique",
  "user_sidebar_contact_us",
  "user_sidebar_change_password",
  "user_sidebar_hide_simulate_loading",
  "user_sidebar_change_ui_simulate_loading",
  "user_sidebar_sidebar_redirect_admin",
  "user_sidebar_hide_discount",
  "user_sidebar_programming_transport",
  "user_sidebar_my_drivers",
  "user_sidebar_new_order",
  "user_sidebar_appointment_title",

  // FEATURES FLAGS ESPECÍFICA:
  "user_home_card_new_order",
  "user_home_card_your_orders",
  "user_home_card_consult_fiscal_notes",
  "user_home_see_banner_communique",
  "is_carrier_type_user",
  "user_create_order_v2",
  "new_driver_bpid",
  "user_my_drivers_download_report_button",
  "pix_method_paycond",
];

export enum SIDEBAR_ADMIN_FLAGS_ENUM {
  NOTIFICATION_FLAG = "admin_sidebar_notification",
  RESET_USER_PASSWORD = "reset_user_password",
}

export enum USER_FLAGS_ENUM {
  USER_NEW_REQUEST_LIST_AMOUNT = "user_new_request_create_option_list_amount",
  USER_CREATE_ORDER_V2 = "user_create_order_v2",
  CASH_PAYMENT = "cash_payment",
  DISABLE_TODAY_CALENDAR = "disable_today_calendar",
  ENABLE_FREIGHT_CONTROL = "enable_freight_control",
  DISABLE_FREIGHT_BY_CENTER = "disable_freight_by_center",
}

export const SIDEBAR_ADMIN_FLAGS = [
  "admin_sidebar_home",
  "admin_sidebar_create_new_user",
  "admin_sidebar_list_user",
  "admin_sidebar_consult_check_receipts",
  "admin_sidebar_change_ui_send_communique",
  "admin_sidebar_block_products",
  "admin_sidebar_contact_us",
  "admin_sidebar_redirect_modo_user",
  "admin_sidebar_hide_send_communique",
  "admin_sidebar_nozzle",
  "admin_sidebar_driver_and_customer",
  SIDEBAR_ADMIN_FLAGS_ENUM.NOTIFICATION_FLAG,
  SIDEBAR_ADMIN_FLAGS_ENUM.RESET_USER_PASSWORD,
];

export enum GLOBAL_FLAGS_ENUM {
  ENABLE_ALPHANUMERIC_CNPJ = "enable_alphanumeric_cnpj",
}

export const { NOTIFICATION_FLAG } = SIDEBAR_ADMIN_FLAGS_ENUM;
export const { RESET_USER_PASSWORD } = SIDEBAR_ADMIN_FLAGS_ENUM;
